import {
  GET_EMPLOYEEASSESSMENT,
  GET_EMPLOYEEASSESSMENT_SUCCESS,
  GET_EMPLOYEEASSESSMENT_FAIL,
  DELETE_EMPLOYEEASSESSMENT,
  DELETE_EMPLOYEEASSESSMENT_SUCCESS,
  DELETE_EMPLOYEEASSESSMENT_FAIL,
  UPDATE_EMPLOYEEASSESSMENT,
  UPDATE_EMPLOYEEASSESSMENT_SUCCESS,
  UPDATE_EMPLOYEEASSESSMENT_FAIL,
  ADD_NEW_EMPLOYEEASSESSMENT,
  ADD_EMPLOYEEASSESSMENT_SUCCESS,
  ADD_EMPLOYEEASSESSMENT_FAIL,
  EMPLOYEEASSESSMENT_LOADING,
  EMPLOYEEASSESSMENT_RESET,
} from "./actionType";

export const resetEmployeeAssessmentState = (actionType) => ({
  type: EMPLOYEEASSESSMENT_RESET,
  payload: { actionType },
});

export const getEmployeeAssessmentSuccess = (actionType, data) => ({
  type: GET_EMPLOYEEASSESSMENT_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeAssessmentFail = (actionType, error) => ({
  type: GET_EMPLOYEEASSESSMENT_FAIL,
  payload: { actionType, error },
});

export const getEmployeeAssessment = data => ({
  type: GET_EMPLOYEEASSESSMENT,
  payload: data,
});

export const getEmployeeAssessmentLoading = () => ({
  type: EMPLOYEEASSESSMENT_LOADING
});

export const deleteEmployeeAssessment = data => ({
  type: DELETE_EMPLOYEEASSESSMENT,
  payload: data,
});

export const deleteEmployeeAssessmentSuccess = data => ({
  type: DELETE_EMPLOYEEASSESSMENT_SUCCESS,
  payload: data,
});

export const deleteEmployeeAssessmentFail = error => ({
  type: DELETE_EMPLOYEEASSESSMENT_FAIL,
  payload: error,
});

export const updateEmployeeAssessment = data => ({
  type: UPDATE_EMPLOYEEASSESSMENT,
  payload: data,
});

export const updateEmployeeAssessmentFail = error => ({
  type: UPDATE_EMPLOYEEASSESSMENT_FAIL,
  payload: error,
});

export const updateEmployeeAssessmentSuccess = data => ({
  type: UPDATE_EMPLOYEEASSESSMENT_SUCCESS,
  payload: data,
});

export const addNewEmployeeAssessment = data => ({
  type: ADD_NEW_EMPLOYEEASSESSMENT,
  payload: data,
});

export const addEmployeeAssessmentSuccess = data => ({
  type: ADD_EMPLOYEEASSESSMENT_SUCCESS,
  payload: data,
});

export const addEmployeeAssessmentFail = error => ({
  type: ADD_EMPLOYEEASSESSMENT_FAIL,
  payload: error,
});